<script>
	import { regionThe, uncap1, uncap, getData, ord, ud, otherRank, otherEst, qui, cha, cur, figs, get_word } from "./utils";
	
	// import Select from "./ui/Select.svelte";
	import Select from "./dropdown/Select.svelte";
	import { load } from "archieml";
	import robojournalist from 'robojournalist';
	import { LineChart, DoubleVerticalBeeswarmChart, BarChart, DistDotPlotChart, IndicatorDistDotPlotChart } from './@onsvisual/svelte-charts';
	import { ScatterChart } from './@onsvisual/svelte-charts';

	import * as d3 from 'd3';

	var place, region, england, props, subDist;

	import * as someJSON from '../data/healthWith2019Values.json';

	import * as storJSON from '../data/stories.json';
	import * as someregJSON from '../data/healthindexdata_reg.json';

	import * as indisJSON from '../data/indis.json';
	import * as indikeyJSON from '../data/indikey.json';
	import * as domluJSON from '../data/domlu.json';
	import * as indluJSON from '../data/indlu.json';

	import * as indicatorDistributionData from '../data/binnedIndicatorDistributions2020.json';
	import * as subDomainDistributionData from '../data/binnedDistributions2020.json';

	// let someJSON = fetch('data/healthWith2019Values.json')
	// let storJSON = fetch('data/stories.json')
	// let someregJSON = fetch('data/healthindexdata_reg.json')
	// let indisJSON = fetch('data/indis.json')

	// import Dropdown from "./dropdown/App.svelte";
	// import Select2 from ".dropdown/Select.svelte";

	import { onMount } from 'svelte';

	
	
	onMount(() => {
		console.log("mount")
		let parent = new URLSearchParams(document.location.search).get("parentUrl");
		let placecode = parent ? parent.split("#")[1] : null;
		console.log("parent", parent)
		console.log("placecode", placecode)
		if (placecode && placecode.length === 9) {
			console.log("code", placecode)
			selected = {'code': placecode}
		}
		
	});


	$: domLU = domluJSON.default
	// $: stor_raw = storJSON.default
	let stor;
	let indis;
	$: if (place) {
		indis = indisJSON.default[place.area]
	}

	$: indikey = indikeyJSON.default
	$: indLU = indluJSON.default

	
	function capi(s) {
		return s.charAt(0).toUpperCase() + s.slice(1);
	}

	$: data = someJSON.default


	$: if (place) {
		region = someregJSON.default[place.region.code]
		england = someregJSON.default['E92000001']
	}
	let options2 = []
	$: if (data) {
		Object.keys(data).forEach(e => {
			options2.push({ 'code': data[e]['area'], 'name': capi(data[e]['name']) })
		}) 
		options2 = options2.sort((a, b) => { 
			if(a.name < b.name) { return -1; }
			if(a.name > b.name) { return 1; }
			return 0;
		 })
	}

	function topbotnp(i, yr, sto) {
		// console.log('ston', sto[i].metric)
		// console.log('yrnp', yr)
		// console.log('rank', place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank)
		// console.log('perc', place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank/307)
		let x = ""
		if (Math.abs(place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank/307) > 0.4) {
			x = x + 'close to average'
		} else {
			if (place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank>0) {
				x = x + "top"
			} else {
				x = x + "bottom"
			}
			if (Math.abs(place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank/307) < 0.05) {
				x = x + (Math.ceil(Math.abs(place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank)*100/307)/100)
			} 
			else if (Math.abs(place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank/307) < 0.1) {
				x = x + 0.1
			}
			else if (Math.abs(place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank/307) < 0.15) {
				x = x + 0.15
			}
			else if (Math.abs(place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank/307) < 0.2) {
				x = x + 0.2
			}
			else if (Math.abs(place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank/307) < 0.25) {
				x = x + 0.25
			}
			else if (Math.abs(place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank/307) < 0.3) {
				x = x + 0.3
			}
			else if (Math.abs(place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank/307) < 0.4) {
				x = x + 0.4
			}
			else if (Math.abs(place.data[domLU[sto[i].metric]].subdomains[sto[i].metric].total[yr].rank/307) < 0.5) {
				x = x + 0.5
			}
		}
		console.log('x', x)
		return x
	}

	// selected = {code: "E07000124", name: 'Ribble Valley'}
	// selected = {code: "E07000223", name: 'Adur'}
	let subtitle
	let subDomains
	let latest_val

	$: console.log("latest_val", latest_val)
	let latest_change
	let indicatorData
	$: console.log('$: selected', selected)
	// $: console.log('$ indicatorData', indicatorData)

	let colWidth;
	// $: colWidth && (selected.code)

	let booleanCheck = false;

	
	$: if(selected) {
		place = data[selected.code]

		place.stories = place.stories.filter( x => x['metric'] != 'Children and young people')

		indicatorData = indisJSON[place["area"]]
		
		stor = storJSON.default[place.area]
		// console.log('stor', storJSON.default)
		// console.log('stor', place.area)
		// console.log('stor', stor)
		console.log("place.stories", place.stories)
		// console.log("stor", stor)

		subDomains = place.stories;
		latest_val = place['data']['Overall']['total']['2020']['value']
		latest_change = place['data']['Overall']['total']['2020']['value'] - place['data']['Overall']['total']['2019']['value']
		// console.log('latest_val', latest_val)
		// console.log('latest_change', latest_change)
		subtitle = place.name + "'s Health Index score "

		
		if ( Math.abs(latest_change) < 0.3 ) {
			subtitle = subtitle + "remained relatively stable in 2020."
		}
		else {
			if ( latest_change < 0 ) {
				subtitle = subtitle + "decreased "
			}
			else {
				subtitle = subtitle + "increased "
			}

			if ( Math.abs(latest_change) > 2 ) {
				subtitle = subtitle + ""
			}
			else if ( Math.abs(latest_change) < 0.8 ) {
				subtitle = subtitle + "slightly "
			}
			subtitle = subtitle + "in 2020."
		}
		asyncLoop();
	}

	var template

    fetch("text/template.txt")
    // fetch("text/template.pug")
        .then((res) => res.text())
        .then((txt) => (template = txt))

	let loaded = false
	let placeload = false
	const onRosaeNlgLoad = () => { loaded = true }

	const asyncLoop = async () => {
		subDist = {}
		for (const i of [0,1,2,3]) {
			const data = await d3.csv('data/'+subDomains[i].metric.replace(/\s/g, '')+'.csv')
			subDist[subDomains[i].metric] = data
		}
	}

	function whichMet(ob) {
		let ar = []
		Object.keys(ob).forEach(e => {
			let tob = {}
			if (dont_compare1yr.includes(e)) {
				if (['rank', 'Change5year Rank'].includes(e)) {
					tob[e] = ob[e]
					ar.push(tob)
				}		
			}
			else {
				if (['rank', 'Change1year Rank', 'Change5year Rank'].includes(e)) {
					tob[e] = ob[e]
					ar.push(tob)
				}
			}
		});
		ar.sort((a, b) => {
			return Math.abs(Object.values(a)[0]) - Math.abs(Object.values(b)[0]);
		});
		return Object.keys(ar[0])[0]
	}

	function indiSort(ob, index, change) {

		// Create an array that orders objects based on the value of a metric given a qualifier (eg change5year)
		let ar = []
		// console.log('ob', ob)
		Object.keys(ob).forEach(e => {
			let temp_ob = {}
			if (change == 'rank') {
				temp_ob[e] = Math.round(10*ob[e][2020])/10
			}
			else if (change == 'Change5year') {
				temp_ob[e] = Math.round( (ob[e][2020] - ob[e][2015])*10 )/10
			} else {
				temp_ob[e] = Math.round( (ob[e][2020] - ob[e][2019])*10 )/10
				// console.log("e", e)
				// console.log("temp_ob[e]", temp_ob[e])
			}
			ar.push(temp_ob)
		})
		ar.sort((a, b) => {
			return Object.values(b)[0] - Object.values(a)[0];
		});
		// console.log('ar', ar)

		if (index == -1) {
			index = ar.length -1
		}
		else if (index == -2) {
			index = ar.length -2
		}

		let inciar = ["Low birth weight"]

		let indiname = Object.keys(ar[index])[0]

		let incidents = ""

		if (inciar.includes(indiname)) {
			incidents = "incidents of "
		}

		return [incidents+uncap(indikey[indiname]), Object.values(ar[index])[0]]
	}

	// Single select
	let selected = null;
	function doSelect(event) {
		selected = event.detail;
		console.log("selected", selected)

		loadArea(selected['code'])
	}
	function doClear() {
		selected = null;
	}


	function loadArea(code) {
		place = data[code]
		indicatorData = indisJSON[place["area"]]

		booleanCheck=false
		setTimeout(() => booleanCheck = true, 100)
	}

	function iterate(obj, pname) {
		Object.keys(obj).forEach(key => {
			if (typeof obj[key] === 'object') {
				iterate(obj[key], pname)
			} else {
				obj[key] = robojournalist(obj[key], {
					plcname: pname,
				})
			}
		})
	}
	$: console.log('place', place)
	$: console.log('indis', indis)

	let twoindis = ['Access to green space', 'Crime', 'Difficulties in daily life']
	let dont_compare1yr = ["Mental health", "Mortality"]

	function results(place) {

		let caveats = {
			"Difficulties in daily life": `"Frailty" measures hospital admissions as a result of a hip fracture in those aged 65 years and over. Figures may have been affected by higher mortality rates in frailer people during the pandemic, or people being less exposed to injury while less active and staying at home.`,
			"Mental health": `Self-harm figures are counted through hospital admissions and so not all cases are recorded. During the coronavirus pandemic, people may have been less likely to seek help at hospital because of fears of infection or overwhelming services. Suicides per area are based on a three-year period, so these figures show longer-term trends rather than a change year to year. Suicide registrations were also affected by inquest delays during the coronavirus pandemic.`,
			"Mortality": `Infant mortality data are based on registrations over a three-year period as numbers in individual areas are low. This means trends are longer term than one year. Infant mortality registrations were also affected by delays to inquests during the coronavirus (COVID-19) pandemic.`,
			"Behavioural risk factors": `Drug and alcohol misuse are difficult to measure. For alcohol misuse, we count hospital admissions; however, during the coronavirus (COVID-19) pandemic people may have been less likely to seek help at hospital because of fears of infection or overwhelming services. Alcohol misuse is also sometimes hidden and not recorded.`,
			"Access to services": `In-person services in this category were limited during the coronavirus pandemic.`
		}
		let caveatsNoise = {
			"Living conditions": `Data for noise complaints are based on the previous year, so this measure will not yet show coronavirus pandemic effects.`
		}
		let dont_include = ['Household overcrowding', 'Child poverty', 'Smoking', 'Children and young people', 'Early years development', 'Pupil absences', 'Pupil attainment']

		let preres = rosaenlg_en_US.render(template, {
			language: 'en_UK',
			twoindis: twoindis,
			place: place,
			caveats: caveats,
			caveatsNoise: caveatsNoise,
			dont_include: dont_include,
			region: region,
			england: england,
			sto: place.stories,
			orda: place.stories.sort((a, b) =>  b.value  - a.value ),
			parent: uncap1(regionThe(region.name)),
			uncap: uncap,
			get_word: get_word,
			figs: figs,
			otherEst: otherEst,
			cur: cur,
			cha: cha,
			qui: qui,
			otherRank: otherRank,
			ud: ud,
			ord: ord,
			whichMet: whichMet,
			topbotnp: topbotnp,
			domLU: domLU,
			indLU: indLU,
			indis: indis,
			indiSort: indiSort,
			indikey: indikey,
			negs: ['smoking', 'anxiety', 'alcohol misuse', 'drug misuse', 'neighbourhood noise', 'air pollution', 'depression', 'self-harm', 'suicides', 'cancer', 'kidney disease', 'cardiovascular conditions', 'crime', 'unemployment', 'low pay', 'difficulties in daily life', 'avoidable mortality', 'infant mortality', "sexually transmitted infections", "hypertension", "low birth weight", "overweight and obesity in adults", "overweight and obesity in children", "cancer", "cardiovascular conditions", "dementia", "diabetes", "kidney disease", "musculoskeletal conditions", "respiratory conditions", "feelings of anxiety", "avoidable mortality", "infant mortality", "self-harm", "suicides", "rough sleeping", "air pollution", "household overcrowding", "noise complaints", "unemployment", "child poverty", "disability", "hip fractures", "low level crime", "personal crime", "pupil absences", "teenage pregnancy", "sedentary behaviour", "smoking", "alcohol misuse", "drug misuse", "distance to gp services", "distance to pharmacies", "distance to sports or leisure facilities", "mortality", "physiological risk factors", "physical health conditions", "difficulties in daily life", "behavioural risk factors", "mental health conditions", "high blood pressure", "frailty"],
		})
		
		return preres.split(`<div id="esc123"></div>`)
	}

	function makeChartData(place, region, england, i) {
		let temp = []
		let arr = [place, region, england]
		if (place) {
			for (const k in {2015: "", 2016: "", 2017: "", 2018: "", 2019: "", 2020: ""}) {
				for (const j in arr) {
					let top = arr[j].data[domLU[place.stories[i].metric]]['subdomains'][place.stories[i].metric].total
					temp.push({
						year: parseInt(k),
						value: top[k]['value'].toFixed(1),
						group: arr[j].name
					});
				}
			}
		}
		return temp
	}


	function makeProps(i, place) {
		if (i==5) {
			return props = {
				area: place,
				data: indicatorData,
				distributionData: indicatorDistributionData,
				width: colWidth
			}
		}
		else if ((i==0)|(whichMet(subDomains[i]) == 'rank')|(['Access to green space', 'Access to services'].includes(subDomains[i].metric))) {
			// SCATTER
			let chart_data 
			let yKey
			let zKey
			if (i==0) {
				chart_data = subDomains.map(d => ({ 'id': (subDomains[i].metric==d.metric)?d.metric:'Other subdomains', 'unique': d['metric'], 'value': d['value'], 'value2019': d['value2019'] })).reverse()
				chart_data.sort((a, b) => a.value - b.value)
				yKey = 'unique'
				zKey = 'unique'
			}
			else {
				chart_data = subDist[subDomains[i].metric].map(d => ({ 'id': d['RGN21NM'], 'unique': d['AREANM'], 'value': (d['time6']), 'value2019': (d['time5']) }))

				chart_data.forEach((item, i) => {
					if (item.unique==place.name) {
						item.id = place.name
					} else if (item.id == place.region.name) {
						item.id = region.name
					} else {
						item.id = "Rest of England"
					}
				});
				chart_data.push({'id': 'England', 'unique': 'England', 'value': england.data[domLU[subDomains[i].metric]].subdomains[subDomains[i].metric].total[2019].value, 'value2019': england.data[domLU[subDomains[i].metric]].subdomains[subDomains[i].metric].total[2019].value})

				chart_data = chart_data.filter(d => d.id != 'Rest of England')

				yKey = null
				zKey = 'id'
			}

			return props = {
				i: i,
				topic: subDomains[i],
				data: chart_data,
				xKey: "value",
				yKey: yKey,
				zKey: zKey,
				distributionData: subDomainDistributionData,
				width: colWidth
				// title: "Multi-line chart"
			}
		} else {
			// LINE
			return props = {
				topic: subDomains[i],
				data: makeChartData(place, region, england, i),
				xKey: "year",
				yKey: "value",
				zKey: "group",
				area: false,
				width: colWidth
				
				// title: "Multi-line chart"
			}
		}
	}



</script>

<svelte:head>
	<script src="./rosaenlg.js" on:load="{onRosaeNlgLoad}"></script>
</svelte:head>

<img id="imagebanner" src="Health-index-tool_webpage-illustration-v4_1@2x.png" alt="Health Index Graphic" style="width: 637px;">
<div id="topdiv" style="background-color: #2060951A; width: 637px; margin-top: -120px;">
	<div style='height: 120px;'></div>
	<div style='padding: 20px;'>
		<h4 id='dropdowntitle'>What is my area’s Health Index score?</h4>

		<div>
			<p id='dropdowntext'>
				Choose an area to see how different aspects of health have changed. The topics shown are selected based on rules pre-programmed by Office for National Statistics (ONS) staff, and the text is generated using semi-automated journalism.
			</p>
			<div id="dropdown">
				<div style="widht: 79.79px; height: 79.79px; margin: 20px auto;">

					{#if (options2.length==307)}

					<form>
						<!-- <label for="single">Select one local authority:</label> -->
						<!-- <Select id="single" idKey="areacd" labelKey="areanm" {items} on:select={doSelect} on:clear={doClear}/> -->
						<Select id="single" idKey="code" labelKey="name" items={options2} on:select={doSelect} on:clear={doClear}/>
					</form>
					
					{/if}


					<!-- <Select options={options2} bind:selected value={selected} label="name" search={true} on:select="{() => { if (selected) { loadArea(selected.code) }}}"/>				   -->
				</div>
			</div>

		</div>
		{#if place}

		{#if loaded}
		{#if options2}
		{#if template}
		{#if domLU}
		{#if indLU}
			<hr style="border: 1px solid #3D6092; color: #3D6092; background-color: #3D6092;">

			<div style="display: flex; justify-content: space-around; flex-direction: row; align-items:center; margin: 20px 20px 20px 0px; position: relative;">
				<p class="mainScoreAccompText" style="flex-basis: auto; font-weight: 700; font-size: 24px; color: rgb(32, 96, 149); float: left; line-height: 28px; margin-bottom: 0px; max-width: 80%;">Health Index score for <span style="color: #00A3A6;">{place.name}: </span></p>
				<div style="flex-basis:auto">
					<div style="font-weight: 700; font-size: 25px; background: #4DBFC1; color: white; height: 77px; width: 77px; border-radius: 40px; text-align: center; line-height: 80px; border: white 2px solid; outline: #F3985C 4px solid;">{(Math.round(latest_val*10)/10).toFixed( 1 ) }</div>
				</div>
			</div>
			<!-- <span style="height: 25px; width: 25px; background-color: "></span> -->
			<!-- <ellipse cx="200" cy="80" rx="100" ry="50" /> -->
			<hr style="border: 1px solid #3D6092; color: #3D6092; background-color: #3D6092; margin-bottom: 20px;">
			<p style="font-weight: 400; font-size: 18px; color: #206095;">{subtitle}</p>

			<p style="font-weight: 400; font-size: 18px; color: #206095;">{place.name} has an overall Health Index score of {(Math.round(latest_val*10)/10).toFixed( 1 ) }, which <span style="color: #00A3A6; font-weight: 700;">{latest_change>0?'is up' : latest_change<0? 'is down' : 'has changed'} { (Math.round(Math.abs(latest_change)*10)/10).toFixed( 1 ) } points</span> compared with the previous year.</p>
		{:else}
			<div style="padding-left: 40%;">Loading...</div>
		{/if}
		{/if}
		{/if}
		{/if}
		{/if}
		{/if}

	</div>
</div>

<div style="height: 10px"></div>
{#if loaded}
{#if options2}
{#if template}
{#if domLU}
{#if indLU}
		<div class="wrapper">

		<div class="col" bind:clientWidth={colWidth}>
		<div style="margin-right: 32px;">
			{#if place}	
			{#if indicatorData}	

			{#each results(place) as res, i (i)}
				{@html res}
				{#if i<4}
					{#if subDist[subDomains[i].metric]}
						<svelte:component this="{
						(i==0)? DistDotPlotChart : 
						(['Access to green space', 'Access to services'].includes(subDomains[i].metric)) ? DoubleVerticalBeeswarmChart :
						(whichMet(subDomains[i]) == 'rank') ? DoubleVerticalBeeswarmChart:
						LineChart}" 
						{...makeProps(i, place)}
						colWidth={colWidth}/>
					{/if}

				<!-- {:else if i==4}
					<svelte:component this="{(i==4)? IndicatorDistDotPlotChart : IndicatorDistDotPlotChart}" {...makeProps(i, place, indicatorData)}/> -->
				{/if}
			{/each}

			{#if booleanCheck}
					<svelte:component this="{IndicatorDistDotPlotChart}" {...makeProps(5, place)}
					colWidth={colWidth}
					/>
			{/if}


				

			{/if}
			{/if}
		</div>
		</div>

		</div>

{:else}
	<div style="padding-left: 40%;">Loading...</div>
{/if}
{/if}
{/if}
{/if}
{/if}

<style>

	.wrapper {
		width: 100%;
		margin: 0 auto;
		padding: 0 16px;
	}

	@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
	:global(body) {
		font-family: 'Open Sans', sans-serif;
		padding: 0px;
		line-height: 2;
		color: #323132;
	}
	#dropdowntitle {
		font-family: 'Open Sans', sans-serif;
		color: #206095 !important;
		font-weight: 700;
		font-size: 26px;
		line-height: 36.4px;
	}
	#dropdowntext {
		font-family: 'Open Sans', sans-serif;
		color: #206095;
		font-weight: 400;
		font-size: 18px;
		line-height: 28px;
	}

	main {
		text-align: left;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
		width: 640px
	}

	h1 {
		font-size: 3em;
		line-height: 1.5;
	}

	@media screen and (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	@media screen and (min-width: 390px) {
		.mainScoreAccompText {
			font-size: 20px;
            line-height: 24px;
		}
	}


	div#visph {
		background-color: #afcbd6;
		color: #003C57;
		height: 240px;
		padding: 80px;
		font-size: 3rem;
		font-weight: 600;
	}
	span.back-to-top {
		text-decoration: underline;
		color: #206095;
		cursor: pointer;
	}
	div#sf {
		background-color: #F5F5F6;
		padding: 15px;
		font-size: 1.2rem;
	}



	:global(body) {
	  margin:0;
	  padding:0;
	  font-family: 'Open Sans', sans-serif;
	  font-size: 14px !important;
	  max-width:950px;
	  margin: 0px auto;
	  display: block;
	  color: #323132 !important;
	}
	:global(#callout-text > p) {
		color: white
	}
	:global(div.container) {
	  /* width: 640px;; */
	  margin: auto;
	}

	:global(div#pcSearch) {
		background: #20609540;
		width: 100%;
		/* border-radius: 10px; */
	}
	:global(div#pcSearch-inner) {
		width: 90%;
		padding: 24px;
	}
	:global(p#searchLabel) {
		font-size: x-large !important;
		color: #206095;
		font-weight: bold;
	}
	:global(p#subhead) {
	  font-size: 20px;
	}
	:global(h2) {
	  font-size: 30px;
	  margin: 32px 0 32px 0;
	  padding: 24px 0 0 0;
	  font-weight: bold;
	  line-height: 40px;
	}
	:global(h3) {
	  font-size: 24px;
	  margin: 32px 0 16px 0;
	  padding: 24px 0 0 0;
	  font-weight: bold;
	  line-height: 32px;
	}
	:global(h4) {
	  font-size: 18px;
	  margin: 24px 0 16px 0;
	  padding: 24px 0 0 0;
	  font-weight: bold;
	  line-height: 32px;
	}

	:global(div#co-box) {
	  display: grid !important;
	  grid-template-columns: 30% auto;
	  gap: 3%;
	  background: #1F6095;
	  background-color: #206095 !important;
	  padding: 20px;
	  margin-bottom: 20px;
	  padding-left: 0;
	  /* border-radius: 10px; */
	}
	:global(#callout-text > p) {
		margin: 15px 15px;
	}
	@media screen and (max-width: 500px) {
		:global(div#co-box) {
			grid-template-columns: auto !important
		}
		:global(div#callout-bigno4d) {
			border-right: none !important;
			border-bottom: 1px solid white;
			height: 80px;
			width: 60%;
			margin: auto;
		}		
		:global(div#callout-bigno3d) {
			border-right: none !important;
			border-bottom: 1px solid white;
			height: 80px;
			width: 60%;
			margin: auto;
		}
		:global(div#callout-text) {
			width: 80%;
    		margin: auto;
		}
		/* :global(#callout-text > p) {
			text-align: justify;
		} */

	}
	:global(div#callout-text) > p {
	  color: white;
	  /* margin: 0px 0px 0px 0px; */
	}
	:global(div#callout-bigno3d) {
	  position: absolute;
	  /* width: 120px; */
	  border-right: 1px solid white;
	  position: relative;
	  text-align: center;
	}
	:global(div#callout-bigno3d > p) {
	  color: white;
	  font-size: xxx-large;
	  font-weight: bold;
	  top: 50%;
	  left: 50%;
		position: absolute;
		transform: translate(-50%, -50%);
	}
	:global(div#callout-bigno4d) {
	  position: absolute;
	  /* width: 150px; */
	  border-right: 1px solid white;
	  position: relative;
	  text-align: center;
	}
	:global(div#callout-bigno4d > p) {
	  color: white;
	  font-size: xxx-large;
	  font-weight: bold;
	  top: 50%;
	  left: 50%;
		position: absolute;
		transform: translate(-50%, -50%);
	}
	:global(.dropdown) {
		height: 44px;
		border-style: solid;
		color: #206095;
		background-color: #FFF;
		font-size: 1.1em;
		border: none;
		box-shadow: none;
		border-radius: 0;
		background: transparent;
		cursor: pointer;
		outline: none;
		padding-left: 6px;
		margin-bottom: 20px;
		border: 2px solid #206095;
		-moz-appearance: none;
		-webkit-appearance: none;
		}

		:global(.dropdown:focus-within) {
box-shadow: 0 0 0px 3pt orange;
}
:global(p#score) {
color: #206095;
/* font-style: italic; */
}

	:global(div.funky) {
		background-color: #206095;
		height: 4px;
		width: 100%;
		/* border-radius: 5px; */
	}
	:global(p) {
		font-size: 18px;
		font-weight: 400;
		line-height: 32px;
		margin: 0 0 24px 0;
		padding: 0;
		color: #323132;
	}

	@media screen and (max-width: 767px) {
		:global(p) {
			font-size: 16px;
		}

	}

	/* @media screen and (min-width: 992px) {
		.col {

		}
	} */
	.col {
		width: 100%;
		float: left;
	}
	@media screen and (min-width: 768px) {
		.col {
			margin: 0;
			/* margin-left: 16px!important; */
			width: 640px;
		}
	}

	:global(h4) {
		font-size: 18px;
		line-height: 24px;
		margin: 16px 0;
		padding: 24px 0 0;
		font-weight: 700;
		color: #323132 !important;
	}
	:global(h5) {
		margin: 0 0 16px;
		font-weight: 400;
		font-size: 16px;
		color: #323132 !important;
	}
	@media screen and (max-width: 767px) {
		:global(h4) {
			font-size: 16px;
		}
		:global(h5) {
			font-size: 14px;
		}
	}
	@media screen and (max-width: 400px) {
		:global(text.label-text) {
			font-size: 10px !important;
		}
	}
	:global(h6) {
		font-size: 16px;
		margin: 16px 0 8px 0;
		font-weight: 700;
		color: #323132;
		font-family: "Open Sans";
	}
</style>